import { useEffect } from "react";

import { resolveLandingTabIdentity } from "./landingTabIdentity";

// Retitles the browser tab and swaps the favicon to match the impersonated brand while a
// target-facing landing page is mounted, then restores the app's own title and favicon on unmount
// so every other page stays Boxphish-branded. `signal` is any text that identifies the brand
// (typically the landing-page path and simulation name).
export default function useLandingTabIdentity(signal) {
    useEffect(() => {
        const iconLinks = Array.from(document.querySelectorAll('link[rel~="icon"]'));
        const originalTitle = document.title;
        const originalIcons = iconLinks.map((link) => link.getAttribute("href"));

        const { title, icon } = resolveLandingTabIdentity(signal);
        document.title = title;
        iconLinks.forEach((link) => link.setAttribute("href", icon));

        return () => {
            document.title = originalTitle;
            iconLinks.forEach((link, index) => {
                const href = originalIcons[index];
                if (href === null) {
                    link.removeAttribute("href");
                } else {
                    link.setAttribute("href", href);
                }
            });
        };
    }, [signal]);
}
